import React, { useState, useRef, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
// import { useMediaQuery } from 'react-responsive';
import Logo from '../../../Visuals/Images/Logo.png';
// import CompanyCheck from './CompanyDashboardCheck.component';
import NewBanner from './NewBanner.component';
import {
  Header,
  TopNav,
  LogoImg,
  DesktopLinks,
  BurgerWrapper,
} from './NavbarStyles.styles';
import OuterBurger from './OuterBurgerComponent.component';
import Auth from '../../../Helpers/auth';
import { httpGetCart } from '../../../Hooks/user/user.get.hooks';
import { useQuery } from '@tanstack/react-query';
import { getGuestCart } from './GuestCart';
import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import {
  FaHome,
  FaShoppingCart,
  FaShoppingBag,
  // FaNewspaper,
} from 'react-icons/fa';
// import BottomNavLinks from './BottomNav.component';

const NavBar = () => {
  const navigate = useNavigate();
  const loggedIn = Auth.loggedIn();

  let userId = null;

  if (loggedIn) {
    const profile = Auth.getProfile();
    userId = profile?.data?.id;
  }

  const { data: cartData = [] } = useQuery({
    queryKey: ['cart', userId || 'guest'],
    queryFn: () => {
      if (userId) {
        return httpGetCart(userId);
      }

      return getGuestCart();
    },
    staleTime: 1000 * 60,
  });

  const cartCount = Array.isArray(cartData) ? cartData.length : 0;

  return (
    <>
      <NewBanner />
      <Header>
        <TopNav>
          <NavLink to="/" className="logoLink">
            <LogoImg src={Logo} alt="Yoda Safety Services Logo" />
          </NavLink>

          <DesktopLinks>
            <NavLink to="/about">About Us</NavLink>
            <Dropdown />
            <TrainingDropdown />
            <NewsResourcesDropdown />
            <NavLink to="/contact-us">Contact Us</NavLink>

            {/* {loggedIn && <CompanyCheck />} */}
            <button
              type="button"
              className="iconButton"
              onClick={(e) => {
                e.preventDefault();
                navigate('/cart');
              }}
              aria-label="Cart"
              style={{ position: 'relative' }}
            >
              <FaShoppingCart />
              {cartCount > 0 && (
                <span
                  style={{
                    position: 'absolute',
                    top: '-7px',
                    right: '-7px',
                    background: '#ff914d',
                    color: '#fff',
                    borderRadius: '50%',
                    padding: '2px 6px',
                    fontSize: '0.75rem',
                    fontWeight: 700,
                    minWidth: '20px',
                    textAlign: 'center',
                    zIndex: 10,
                  }}
                >
                  {cartCount}
                </span>
              )}
            </button>

            {loggedIn ? (
              <>
                <UserDropdown />
              </>
            ) : (
              <PrimaryButton
                functionName={(e) => {
                  e.preventDefault();
                  navigate('/login');
                }}
                span="Login"
              />
            )}
          </DesktopLinks>

          <BurgerWrapper>
            <button
              type="button"
              className="iconButton"
              onClick={(e) => {
                e.preventDefault();
                navigate('/cart');
              }}
              aria-label="Cart"
              style={{ position: 'relative' }}
            >
              <FaShoppingCart />
              {cartCount > 0 && (
                <span
                  style={{
                    position: 'absolute',
                    top: '-7px',
                    right: '-7px',
                    background: '#ff914d',
                    color: '#fff',
                    borderRadius: '50%',
                    padding: '2px 6px',
                    fontSize: '0.75rem',
                    fontWeight: 700,
                    minWidth: '20px',
                    textAlign: 'center',
                    zIndex: 10,
                  }}
                >
                  {cartCount}
                </span>
              )}
            </button>

            {loggedIn ? (
              <>
                <UserDropdown />
              </>
            ) : (
              <PrimaryButton
                functionName={(e) => {
                  e.preventDefault();
                  navigate('/login');
                }}
                span="Login"
              />
            )}
            <OuterBurger />
          </BurgerWrapper>
        </TopNav>
      </Header>
    </>
  );
};

export default NavBar;

function UserDropdown() {
  const [open, setOpen] = useState(false);
  const dropdownRef = React.useRef(null);
  const navigate = useNavigate();

  const profile = Auth.getProfile();
  const type = profile?.data?.type;

  let dashboardPath = '/user';
  let dashboardLabel = 'Your Dashboard';

  if (type === 'Manager') {
    dashboardPath = '/manager';
    dashboardLabel = 'Manager Dashboard';
  }

  if (type === 'Admin') {
    dashboardPath = '/admin';
    dashboardLabel = 'Admin Dashboard';
  }

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    setOpen(false);
    Auth.logout();
    window.location.assign('/');
  };

  return (
    <div
      ref={dropdownRef}
      className={`dropdown userDropdown ${open ? 'open' : ''}`}
    >
      <button
        type="button"
        className="iconButton"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((s) => !s)}
        aria-label="Open user menu"
      >
        <FaHome />
      </button>

      <div className="userDropdownContent" role="menu" aria-hidden={!open}>
        <button
          type="button"
          className="dropdownItem"
          onClick={() => {
            setOpen(false);
            navigate(dashboardPath);
          }}
        >
          {dashboardLabel}
        </button>

        {type === 'Admin' && (
          <button
            type="button"
            className="dropdownItem"
            onClick={() => {
              setOpen(false);
              navigate('/user');
            }}
          >
            Your Dashboard
          </button>
        )}

        <div className="userDropdownDivider" />

        <button
          type="button"
          className="dropdownItem logoutItem"
          onClick={handleLogout}
        >
          Log Out
        </button>
      </div>
    </div>
  );
}

function NewsResourcesDropdown() {
  const [openByClick, setOpenByClick] = useState(false);
  const [openByHover, setOpenByHover] = useState(false);

  const dropdownRef = useRef(null);
  const closeTimeoutRef = useRef(null);

  const open = openByClick || openByHover;

  const handleMouseEnter = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }

    setOpenByHover(true);
  };

  const handleMouseLeave = () => {
    closeTimeoutRef.current = setTimeout(() => {
      setOpenByHover(false);
    }, 150);
  };

  const closeDropdown = () => {
    setOpenByClick(false);
    setOpenByHover(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);

      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      className={`dropdown ${open ? 'open' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        type="button"
        className="dropdownTrigger"
        onClick={() => setOpenByClick((current) => !current)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-controls="news-resources-dropdown-menu"
        style={{
          color: 'var(--yellow4)',
          fontWeight: 'bold',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 'var(--space-s)',
        }}
      >
        {/* <FaNewspaper aria-hidden style={{ marginRight: 'var(--space-s)' }} /> */}
        News & Resources
      </button>

      <div
        id="news-resources-dropdown-menu"
        className="dropdownContent"
        role="menu"
        aria-hidden={!open}
      >
        <NavLink
          to="/news"
          className="dropdownItem"
          role="menuitem"
          onClick={closeDropdown}
        >
          <div className="dropdownTitle">News & Updates</div>
          <div className="dropdownSubtitle">
            Latest announcements and articles
          </div>
        </NavLink>

        <NavLink
          to="/resources"
          className="dropdownItem"
          role="menuitem"
          onClick={closeDropdown}
        >
          <div className="dropdownTitle">Resources</div>
          <div className="dropdownSubtitle">Guides, downloads and help</div>
        </NavLink>

        <NavLink
          to="/digital-safety-forms"
          className="dropdownItem"
          role="menuitem"
          onClick={closeDropdown}
        >
          <div className="dropdownTitle">Digital Safety Forms</div>
          <div className="dropdownSubtitle">Online forms and submissions</div>
        </NavLink>

        <NavLink
          to="/safety-manuals"
          className="dropdownItem"
          role="menuitem"
          onClick={closeDropdown}
        >
          <div className="dropdownTitle">Safety Manuals</div>
          <div className="dropdownSubtitle">
            Downloadable manuals and policies
          </div>
        </NavLink>

        <NavLink
          to="/safety-audits"
          className="dropdownItem"
          role="menuitem"
          onClick={closeDropdown}
        >
          <div className="dropdownTitle">Safety Audits</div>
          <div className="dropdownSubtitle">Audit templates and checklists</div>
        </NavLink>
      </div>
    </div>
  );
}

function TrainingDropdown() {
  const [openByClick, setOpenByClick] = useState(false);
  const [openByHover, setOpenByHover] = useState(false);
  const dropdownRef = useRef(null);
  const closeTimeoutRef = useRef(null);

  const open = openByClick || openByHover;

  const handleMouseEnter = () => {
    if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
    setOpenByHover(true);
  };
  const handleMouseLeave = () => {
    closeTimeoutRef.current = setTimeout(() => setOpenByHover(false), 150);
  };
  const closeDropdown = () => {
    setOpenByClick(false);
    setOpenByHover(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div
      ref={dropdownRef}
      className={`dropdown ${open ? 'open' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        type="button"
        className="trainingTrigger"
        onClick={() => setOpenByClick((c) => !c)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-controls="training-dropdown-menu"
        style={{
          color: 'var(--yellow4)',
          fontWeight: 'bold',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 'var(--space-s)',
        }}
      >
        Training
      </button>

      <div
        id="training-dropdown-menu"
        className="dropdownContent"
        role="menu"
        aria-hidden={!open}
      >
        <NavLink
          to="/training"
          className="dropdownItem"
          role="menuitem"
          onClick={closeDropdown}
        >
          <div className="dropdownTitle">All Training</div>
          <div className="dropdownSubtitle">Browse public courses</div>
        </NavLink>

        <NavLink
          to="/company-training"
          className="dropdownItem"
          role="menuitem"
          onClick={closeDropdown}
        >
          <div className="dropdownTitle">Company Training</div>
          <div className="dropdownSubtitle">
            Tailored company training options
          </div>
        </NavLink>
      </div>
    </div>
  );
}

function Dropdown() {
  const [openByClick, setOpenByClick] = useState(false);
  const [openByHover, setOpenByHover] = useState(false);

  const dropdownRef = useRef(null);
  const closeTimeoutRef = useRef(null);

  const open = openByClick || openByHover;

  const handleMouseEnter = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }

    setOpenByHover(true);
  };

  const handleMouseLeave = () => {
    closeTimeoutRef.current = setTimeout(() => {
      setOpenByHover(false);
    }, 150);
  };

  const closeDropdown = () => {
    setOpenByClick(false);
    setOpenByHover(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);

      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      className={`dropdown ${open ? 'open' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        type="button"
        className="dropdownTrigger"
        onClick={() => setOpenByClick((current) => !current)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-controls="shop-dropdown-menu"
        style={{
          color: 'var(--yellow4)',
          fontWeight: 'bold',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 'var(--space-s)',
        }}
      >
        <FaShoppingBag aria-hidden style={{ marginRight: 'var(--space-s)' }} />
        Shop
      </button>

      <div
        id="shop-dropdown-menu"
        className="dropdownContent"
        role="menu"
        aria-hidden={!open}
      >
        <NavLink
          to="/explore-products"
          className="dropdownItem"
          role="menuitem"
          onClick={closeDropdown}
        >
          <div className="dropdownTitle">Explore Products</div>
          <div className="dropdownSubtitle">
            Browse available product categories
          </div>
        </NavLink>

        <NavLink
          to="/shop"
          className="dropdownItem"
          role="menuitem"
          onClick={closeDropdown}
        >
          <div className="dropdownTitle">How to Purchase</div>
          <div className="dropdownSubtitle">Learn how to order products</div>
        </NavLink>
      </div>
    </div>
  );
}
